export default __webpack_public_path__ + "bf3a20255d06941e62597e5131dcda50.jpg";